module.exports = __webpack_public_path__ + "static/media/logo.5200c021.svg";